import { useSnackbar } from "notistack";
import * as React from "react";

import { sendPhoneNumberAuthCode as sendCode } from "@/api/sendPhoneNumberAuthCode";
import { useResendCooldown } from "@/hooks/useResendCooldown";

export const useSendPhoneNumberAuthCode = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [isSending, setIsSending] = React.useState(false);
  const [cooldownPhoneNumber, setCooldownPhoneNumber] = React.useState<string>();
  const { remaining, restart } = useResendCooldown(0);
  const inFlight = React.useRef(false);
  const mounted = React.useRef(true);
  React.useEffect(() => {
    mounted.current = true;
    return () => { mounted.current = false; };
  }, []);

  const sendPhoneNumberAuthCode = async (phoneNumber: string) => {
    if (inFlight.current) return undefined;
    inFlight.current = true;
    setIsSending(true);
    try {
      const result = await sendCode(phoneNumber);
      if (!mounted.current) return undefined;
      if (result.retryAfter !== undefined) {
        setCooldownPhoneNumber(phoneNumber);
        restart(result.retryAfter);
      }
      if (result.success) {
        enqueueSnackbar("電話番号認証コード送信に成功しました。", { variant: "success" });
      } else {
        enqueueSnackbar(result.error, { variant: result.kind });
      }
      return result;
    } finally {
      inFlight.current = false;
      if (mounted.current) setIsSending(false);
    }
  };

  return { sendPhoneNumberAuthCode, isSending, cooldownPhoneNumber, remaining };
};
